import React, { Component } from 'react';
import Firebase from 'firebase';
import { browserHistory } from 'react-router'
import Select from 'react-select';
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);



class addAdmin extends Component {
    constructor() {
        super();
        this.state = {
            user_id: "",
            name: "",
            rut: "",
            email: "",
            created_at: "",
            modified_at: "",
            password: "",
            spinner: true
        }
        this.renderButton = this.renderButton.bind(this);
        this.setFirebase = this.setFirebase.bind(this);
    }
    componentWillMount() {
        var newUserKey = Firebase.database().ref().child('admin_users').push().key;
        this.setState({ user_id: newUserKey});
        var options = []
        var clientsRef = Firebase.database().ref("clients");
        clientsRef.on("value", snap => {
            this.setState({ clients: snap.val() })
            Object.keys(snap.val()).map(client => {
                options.push({ value: client, label: client })
            })
            this.setState({ options: options })
        })
    }

    componentDidMount() {
        this.setState({ token: JSON.parse(localStorage["firebase:authUser:AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384:[DEFAULT]"]).stsTokenManager.accessToken });
    }



    setFirebase() {
        const urlprox = 'https://us-central1-operatio-a399c.cloudfunctions.net/api/admin/createUser';
        const urldev = 'https://us-central1-operatio-pro-dev-493b8.cloudfunctions.net/api/admin/createUser';
        const data = {
            isAdmin: true,
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            rut: this.state.rut,
            client_id: this.state.client_id
        };

        fetch(urldev, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.state.token
            }
        })
            .then((response) => {
                switch (response.status) {
                    case 403:
                        this.refs.container.warning(
                            "USUARIO NO FUE CREADO",
                            "verifique que el email no este registrado o que esté bien escrito", {
                                timeOut: 3000,
                                extendedTimeOut: 10000
                            });
                        this.setState({ spinner: true })
                        break;
                    case 201:
                        return response.json();
                    default:
                        break;
                }
            })
            .then(jsonResponse => {
                if (jsonResponse !== undefined) {
                    this.props.callBack(this.state.name);
                }
            })
            .catch(error => {
            });

    }

    renderButton() {
        if (this.state.rut && this.state.name && this.state.email && this.state.password) {
            return (
                <div>
                    {
                        this.state.spinner
                            ?
                            <a className="btn btn-success" onClick={() => { this.setFirebase(); this.setState({ spinner: false }) }} >Crear usuario</a>
                            :
                            <a className="btn btn-success"><i className="fa fa-refresh fa-spin"></i> Enviando datos...</a>
                    }
                </div>

            )
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <ToastContainer ref="container"
                        style={{ top: "60px" }}
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right"
                    />
                    <div className="col-sm-12">
                        <div className="form-group">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Rut</label>
                                <input type="text" className="form-control" id="rut" placeholder="Rut Usuario"
                                    value={this.state.rut}
                                    onChange={(e) => { this.setState({ rut: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre</label>
                                <input type="text" className="form-control" id="inputName" placeholder="nombre del usuario"
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Email</label>
                                <input type="text" className="form-control" id="inputEmail"
                                    placeholder="Email del usuario"
                                    value={this.state.email}
                                    onChange={(e) => { this.setState({ email: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Client:</label>
                                <Select
                                    name="form-field-name"
                                    value={this.state.client_id}
                                    options={this.state.options}
                                    onChange={(e) => this.setState({ client_id: e.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Contraseña</label>
                                <input type="text" className="form-control" id="inputEmail"
                                    placeholder="Contraseña para el usuario"
                                    value={this.state.password}
                                    onChange={(e) => { this.setState({ password: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <div className="col-lg-10 text-right">
                                    {
                                        this.renderButton()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default addAdmin;


// WEBPACK FOOTER //
// ./src/views/administracion/admins/addAdmin.js